import { autoinject, bindable } from 'aurelia-framework';
import { NodeModel } from "../../../models/node-model";

/** UI component for showing organizational structure tree
 *  
 *  This component is otherwise similar to organizational-units (which is used 
 *  in customer's organizational structure view/editor), but this component
 *  only shows the pre-fetched data, when the organizational-units component
 *  fetches the data itself.
 * 
 *  This component is used in measure input view, and is identical
 *  in functionality with the service-structure component used there.
 */
@autoinject
export class OrganizationalStructure {
	@bindable searchTerm: string;

	@bindable nodes: NodeModel[];
	@bindable selectedNode: NodeModel;
}
